import { Button } from '@shared/ui/button/button.component';
import { EmptyState } from '@shared/ui/empty-state/empty-state.component';
import { Logo } from '@shared/ui/logo/logo.component';
import { useTranslation } from 'react-i18next';

import styles from './not-found.component.module.css';

/**
 * The 404 page. Renders from the route ErrorBoundary (outside the app shell), so
 * it carries its own branding and a way home rather than a bare error string.
 */
export function NotFound() {
	const { t } = useTranslation();

	return (
		<main className={styles.notFound}>
			<a href="/" className={styles.logo} aria-label={t('nav.home', 'Home')}>
				<Logo />
			</a>
			<EmptyState
				icon={<span className={styles.code}>{t('notFound.badge', '404')}</span>}
				title={t('notFound.title', 'Page not found')}
				description={t(
					'notFound.description',
					'That page has moved or never existed. Check the link, or head back to your board.',
				)}
			>
				<Button asChild>
					<a href="/">{t('notFound.home', 'Back to the board')}</a>
				</Button>
			</EmptyState>
		</main>
	);
}
